import React, { Component } from "react";
import {
  Button,
  Container,
  Header,
} from "semantic-ui-react";

export default class BookInform extends Component {
  render() {
    return (
      <Container text>
        <Header as="h1">Before You Start</Header>
        <p>
          Thank you for your interest in CustomBook. <br/><br/>This test website is intended to
          help us streamline the book making process and offers a one way flow of
          pictures for us to receive your information. Once your pictures and information
          have been submitted, we will animate the pictures, write the story, and send
          you the book. <br/><br/>The books will take roughly 3 weeks to arrive.
        </p>
        <Button primary onClick={this.props.onNext}>
          Next
        </Button>
      </Container>
    );
  }
}
